import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import Routes from './routes/index';
import * as serviceWorker from './serviceWorker';
import { init, ErrorBoundary, BrowserTracing } from '@sentry/react';
import ErrorFallback from './components/UI/Organisms/ErrorFallback';

import './index.scss';

import ReactGA from 'react-ga';

ReactGA.initialize('UA-104483477-1');
ReactGA.pageview(window.location.pathname + window.location.search);

if (process.env.REACT_APP_SENTRY) {
  init({ dsn: process.env.REACT_APP_SENTRY, integrations: [new BrowserTracing()], tracesSampleRate: 1.0 });
}

// A deploy replaces the hashed chunk files. A page loaded before it (e.g. a web-view left open in the app)
// then fails to import its next lazy route; reload once to pick up the new index.html. The timestamp
// stops a reload loop if the chunk still fails right after reloading.
window.addEventListener('vite:preloadError', () => {
  try {
    const key = 'opweb-chunk-reload-at';
    if (Date.now() - (Number(sessionStorage.getItem(key)) || 0) < 10000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch (e) {
    return;
  }
  window.location.reload();
});

ReactDOM.render(
  <ErrorBoundary fallback={ErrorFallback}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
